import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { HypersceneAdvancedDemo } from '../../hyperscene-advanced.component';

/**
 * The Quality tab: visual quality profile, shading and CAD effects. The page owns the state; this component only
 * renders it, so it is checked with the page.
 */
@Component({
  selector: 'section[viewer-quality-panel]',
  templateUrl: './viewer-quality-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ViewerQualityPanelComponent {
  @Input({ required: true }) public viewer!: HypersceneAdvancedDemo;
}
